// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// third-party
import { useIntl } from 'react-intl';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

export default function Footer() {
  const intl = useIntl();

  return (
    <Stack direction={{ sm: 'row' }} sx={{ gap: 1, justifyContent: 'space-between', alignItems: 'center', pt: 3, mt: 'auto' }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', opacity: 0.8 }}>
        {intl.formatMessage({ id: 'footer-copyright' }, { year: new Date().getFullYear() })}
      </Typography>
    </Stack>
  );
}
